import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { DbService } from 'app/core/services/db.service';
import { Advertisements } from 'app/menu/models/advertisements.model';
import { MenuService } from 'app/menu/services/menu.service';
import * as moment from 'moment';
import { COLLECTIONS_BD } from '../../models/collections.model';

/**
 * COmponente que muestra la publicidad
 */
@Component({
    selector: 'app-ads',
    templateUrl: './ads.component.html',
    styleUrls: ['./ads.component.scss'],
    standalone: false
})
export class AdsComponent implements OnInit {
  /**
   * Identificador de la publicidad
   */
  @Input() id = '';
  /**
   * Indica si la publicidad que se va a buscar es en home o en menu
   */
  @Input() isHomeAd = false;
  /**
   * Indica si ya se cerro el modal o no
   */
  // eslint-disable-next-line @angular-eslint/no-output-native
  @Output() close!: EventEmitter<boolean>;
  /**
   * Informacion de la publicidad activa
   */
  ads: Advertisements[] = [];
  /**
   * Indica si se visualiza o no la publicidad
   */
  isAdOn = false;
  /**
   * Fecha actual
   */
  date = moment(new Date()).format('YYYY-MM-DD');
  /**
   * Indica si la pantalla es mobile o no
   */
  isMobile = true;
  /**
   * Constructor
   *
   * @param db conexion con BD
   */
  constructor(
    private db: DbService,
    private responsiveService: MenuService,
  ) {
    this.close = new EventEmitter();
  }

  /**
   * Valida si hay publicidades
   */
  ngOnInit(): void {
    this.responsiveService.getIsMobile().subscribe((responsive: boolean) => {
      this.isMobile = responsive;
    });
    if (this.isHomeAd) {
      this.validateAdHome();
    } else {
      this.validateAdMenu();
    }
  }

  /**
   * Valida si hay alguna publicidad de home
   * para mostrar
   */
  validateAdMenu(): void {
    this.db.get(COLLECTIONS_BD.advertisements,
      [['toDate', '>=', this.date], ['storeId', '==', this.id], ['home', '==', false], ['isHidden', '==', false]])
      .subscribe((ads: Advertisements[]) => {
        if (ads.length > 0) {
          this.isAdOn = true;
        }
        this.ads = [];
        const adsFiltered = ads.filter((a) => new Date(this.date) >= new Date(a.fromDate));
        if (adsFiltered) {
          this.ads = [adsFiltered[0]];
        }
        setTimeout(() => {
          this.close.emit(false);
          this.isAdOn = false;
        }, 6000);
        if (ads.length === 0 || adsFiltered.length === 0) {
          this.close.emit(false);
          this.isAdOn = false;
        }
      });
  }

  /**
   * Valida si hay alguna publicidad de menu
   * para mostrar
   */
  validateAdHome(): void {
    this.db.get(COLLECTIONS_BD.advertisements,
      [['storeId', '==', this.id], ['toDate', '>=', this.date], ['home', '==', true], ['isHidden', '==', false]])
      .subscribe((ads: Advertisements[]) => {
        if (ads.length > 0) {
          this.isAdOn = true;
        }
        const adsFiltered = ads.filter((a) => new Date(this.date) >= new Date(a.fromDate));
        this.ads = adsFiltered;
        setTimeout(() => {
          this.close.emit(false);
          this.isAdOn = false;
        }, 6000);
        if (ads.length === 0 || adsFiltered.length === 0) {
          this.close.emit(false);
          this.isAdOn = false;
        }
      });
  }


  /**
   * Apaga la publicidad en pantalla
   *
   */
  adsOff(): void {
    this.isAdOn = false;
    this.close.emit(false);
  }

  /**
   * Si el item tiene configurado una URL
   * al darle click navegara a dicha ruta
   *
   */
  goLink(ad: Advertisements): void {
    if (ad.link) {
      window.open(this.ads[0].link, '_blank');
    }
  }

}
